import React from 'react';

import { TabProps } from '../types';

import TabContainer from './styled/TabContainer';

const Tab: React.FC<TabProps> = props => (
  <TabContainer
    active={props.active}
    onClick={props.onClick && props.onClick(props.tabIndex)}
  >
    <div>
      {Array.isArray(props.children) && props.children.length > 1
        ? props.children[0]
        : props.children}
    </div>
  </TabContainer>
);

export { default as TabContent } from './styled/TabContent';
export { default as TabLabel } from './TabLabel';
export default Tab;
